import { render, staticRenderFns } from "./Ticket-timeline.vue?vue&type=template&id=27d43dc5&scoped=true"
import script from "./Ticket-timeline.vue?vue&type=script&lang=js"
export * from "./Ticket-timeline.vue?vue&type=script&lang=js"
import style0 from "./Ticket-timeline.vue?vue&type=style&index=0&id=27d43dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d43dc5",
  null
  
)

export default component.exports